// 📦 UserContext.js
import { createContext, useContext, useEffect, useState } from "react";

// 1. Opret context
export const UserContext = createContext();

// 2. Provider komponent
export function UserProvider({ children }) {
  const [profile, setProfile] = useState(null);

  const fetchProfile = async () => {
    const token = localStorage.getItem("access");
    try {
      const res = await fetch("https://matly-backend.onrender.com/api/profile/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      setProfile(data);
    } catch (err) {
      console.error("Failed to fetch profile:", err);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <UserContext.Provider value={{ profile, setProfile, fetchProfile }}>
      {children}
    </UserContext.Provider>
  );
}

// 3. Custom hook (valgfri, men nice!)
export const useUser = () => useContext(UserContext);